import { type ReactNode } from "react";
import { NoAlarmsIllustration } from "vega-illustrations";

import { useFeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { EmailTextButton } from "@vega-core/components/Buttons/EmailTextButton/EmailTextButton";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

type MaintenanceWrapperProps = {
  children: ReactNode;
};

export const MaintenanceWrapper = ({ children }: MaintenanceWrapperProps) => {
  const { contacts, global } = usePublicConfig();
  const { featureFlag } = useFeatureFlag();

  if (!featureFlag.maintenance_mode) {
    return children;
  }

  return (
    <div className="flex h-dvh w-screen items-center justify-center">
      <div className="flex flex-col items-center justify-center max-w-[37.5rem] text-center">
        <NoAlarmsIllustration />
        <div className="flex flex-col gap-2">
          <h1 className="body-large-semibold">{m.help_weWillBeRightBack()}</h1>
          <p className="body-base-regular">
            {m.help_wereTemporarilyOffline()}
            <br />
            <br />
            {m.help_ifYouNeedHelpInTheM()}{" "}
            <EmailTextButton email={contacts.helpEmail} />{" "}
            {m.help_forReachOut({ companyName: global.companyName })}{" "}
            <EmailTextButton email={contacts.helpEmail} />
          </p>
        </div>
      </div>
    </div>
  );
};
